import { ChangeEvent, useState } from 'react';

import APIs from '../../../../../api';
import { DialogInOne, MpTextField } from '../../../../../components';
import { IdialogInOneProps } from '../../../../../components/DialogInOne';
import { GridBox } from '../../../../../components/Layout';
import { Box } from '../../../../../components/MuiGenerals';
import { useAlerting, useTranslation } from '../../../../../hooks';
import useGridBoxInputValidation from '../../../../../hooks/useGridBoxInputValidation';
import { Iprefix } from '../../../../../hooks/useTranslation';
import { useZusDialogStore } from '../../../../../zustand/store';
import { useZusParams } from '../../hooks';
import { editDistributorNameDialogTranslateKey as TK } from '../../mappings/translate';
import { IapiGetAllRes } from '../../types';

const initFields = { distributorName: '' };

function EditDistributorNameDialog() {
  const translatePrefix: Iprefix = 'distributorAgentList';

  const { t, tc } = useTranslation(translatePrefix);
  const zusDialog = useZusDialogStore();
  const { validateGridBoxInput } = useGridBoxInputValidation();
  const { alerting } = useAlerting();

  const details = zusDialog.meta as IapiGetAllRes;

  const zusParams = useZusParams();
  const [fields, setFields] = useState(initFields);

  const onClose = async () => {
    await zusDialog.close();

    setFields(initFields);
  };
  const onConfirm = async () => {
    const invalidMessage = validateGridBoxInput(labelElePairArr);

    if (invalidMessage) {
      return alerting('warning', invalidMessage);
    }

    const res = await APIs.setting.distributorAgentList.postEditDistributorName({
      distributorAgentId: details.distributorAgentId,
      newDistributorAgentName: fields.distributorName,
    });

    if (!res) {
      return;
    }

    await onClose();
    alerting('success', t(TK.editDistributorNameSuccess));
    zusParams.refetch();
  };

  const onChange =
    (field: keyof typeof fields) => (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setFields((f) => ({ ...f, [field]: e.target.value }));
    };

  const labelElePairArr: [string, JSX.Element][] = [
    [TK.distributorAgentId, <Box>{details.distributorAgentId}</Box>],
    [TK.existingDistributorName, <Box>{details.name}</Box>],
    [
      TK.newDistributorName,
      <MpTextField
        label={tc('phInputField', { fieldName: t(TK.newDistributorName) })}
        value={fields.distributorName}
        onChange={onChange('distributorName')}
      />,
    ],
  ];

  const dialogConfig: IdialogInOneProps = {
    title: t(TK.edit),
    self: {
      open: zusDialog.match('editRequestDialog'),
      onClose,
    },
    content: <GridBox labelElePairArr={labelElePairArr} />,
    onConfirm,
    onCancel: onClose,
  };

  return <DialogInOne {...dialogConfig} />;
}

export default EditDistributorNameDialog;
